/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingInformationForSaas extends models.BillingPeriodInformation {
    getFixupPrototypeFunction() { return BillingInformationForSaas.fixupPrototype; }

    static newInstance(model: Partial<BillingInformationForSaas>): BillingInformationForSaas {
        let obj = Object.assign(new BillingInformationForSaas(), model);
        BillingInformationForSaas.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingInformationForSaas>): BillingInformationForSaas {
        if (!model) return null;
        return BillingInformationForSaas.newInstance(<BillingInformationForSaas> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingInformationForSaas) {
        if (!obj) return;

        models.BillingInformationForSaas.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingInformationForSaas): boolean {
        if (models.BillingPeriodInformation.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingInformationForSaas.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
